import { render, staticRenderFns } from "./ControlTextarea.vue?vue&type=template&id=ed3eea50&"
import script from "./ControlTextarea.vue?vue&type=script&lang=js&"
export * from "./ControlTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ControlTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports